{
  "module_key": "app_journey",
  "area_key": "experience_delivery",
  "display_name": "App journey",
  "kind": "native",
  "api_base": "https://os.ketosource.co/app-journey",
  "permission_scopes": [
    "module:app_journey"
  ],
  "tabs": [
    {
      "tab_key": "sequence",
      "display_name": "Sequence",
      "tab_order": 1,
      "permission_scope": "module:app_journey"
    },
    {
      "tab_key": "map",
      "display_name": "Map",
      "tab_order": 2,
      "permission_scope": "module:app_journey"
    }
  ],
  "owner_email": "zach@ketosource.co",
  "help_url": "mailto:zach@ketosource.co"
}
